module.exports = function () {

  var theClass = 'form-headline-mobile hidden-desktop';
  var sharedOptions = {
    id: 'studentagency.de',
    hostname: '//olymp9.sa.cz/shared/'

  };
  var options = {
    letenky: {
      formType: 'round_trip',
      header: {
        text: 'Flugkarten',
        className: theClass
      }
    },
    jizdenky: {
      header: {
        text: 'Buskarten/Zugkarten',
        className: theClass
      }
    }
  };

  Object.keys(options).forEach((key) => {
    options[key] = $.extend({}, sharedOptions, options[key]);
  });

  return options;

};


// WEBPACK FOOTER //
// ./src/js/homepage/forms-defaults.js